import { render, staticRenderFns } from "./suobi_chongzhi.vue?vue&type=template&id=47523611&scoped=true"
import script from "./suobi_chongzhi.vue?vue&type=script&lang=js"
export * from "./suobi_chongzhi.vue?vue&type=script&lang=js"
import style0 from "./suobi_chongzhi.vue?vue&type=style&index=0&id=47523611&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47523611",
  null
  
)

export default component.exports